import { createSlice } from '@reduxjs/toolkit';
import {
  EditAddressSingleOrder,
  EditUserOrder,
  EditUserSingleOrder,
  GetAllUserOrderCount,
  GetMyOrder,
  GetMySelectionOrder,
  GetStatusAdvncaedCount,
  GetUserSingleOrder,
} from './user_order_services_sync';

export const userOrderSlice = createSlice({
  name: 'user_order',
  initialState: {
    my_order_loader: false,
    my_order_details_loader: false,
    order_edit_loader: false,
    order_edit_single_loader: false,
    get_advance_count_loader: false,
    get_all_user_count: {},
    get_all_user_count_loader: false,
    get_advanced_order_count: {},
    order_edit_address_single_loader: false,
    message: '',
    my_order: [],
    myOrderDetails: {},
    cartIndicator: '',
    orderPage: 0,
    orderLimit: 20,
    my_order_status: 'all',
    my_single_order_status: '',
    my_selection_order_status: { value: 'all', label: 'All' },
  },
  reducers: {
    clearState: (state) => {
      state.my_order_loader = false;
      state.my_order_details_loader = false;
      state.order_edit_loader = false;
      state.order_edit_single_loader = false;
      state.get_advance_count_loader = false;
      state.get_all_user_count_loader = false;
      state.order_edit_address_single_loader = false;
      state.get_all_user_count = {};
      state.get_advanced_order_count = {};
      state.message = '';
      state.my_order = [];
      state.myOrderDetails = {};
      state.orderIndicator = '';
      state.orderPage = 0;
      state.my_order_status = 'all';
      state.my_single_order_status = '';
      state.my_selection_order_status = { value: 'all', label: 'All' };

      return state;
    },

    updateOrderIndicator: (state, { payload }) => {
      state.orderIndicator = payload;
    },

    updateMyOrderStatus: (state, { payload }) => {
      state.my_order_status = payload;
    },

    updateMySelectionOrdeState: (state, { payload }) => {
      state.my_selection_order_status = payload;
    },

    updateMySingleOrderStatus: (state, { payload }) => {
      state.my_single_order_status = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetMyOrder.pending, (state) => {
        state.my_order_loader = true;
      })
      .addCase(GetMyOrder.fulfilled, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
        state.my_order = payload?.data;
        state.orderPage = payload?.data?.page;
        state.my_selection_order_status = { value: 'all', label: 'All' };
      })
      .addCase(GetMyOrder.rejected, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetMySelectionOrder.pending, (state) => {
        state.my_order_loader = true;
      })
      .addCase(GetMySelectionOrder.fulfilled, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
        state.my_order = payload?.data;
        state.orderPage = payload?.data?.page;
        state.my_selection_order_status = payload?.my_selection_order;
      })
      .addCase(GetMySelectionOrder.rejected, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetUserSingleOrder.pending, (state) => {
        state.my_order_details_loader = true;
      })
      .addCase(GetUserSingleOrder.fulfilled, (state, { payload }) => {
        state.my_single_order_status = payload?.data?.status;

        state.my_order_details_loader = false;
        state.message = payload?.message;
        state.myOrderDetails = payload?.data;
      })
      .addCase(GetUserSingleOrder.rejected, (state, { payload }) => {
        state.my_order_details_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(EditUserOrder.pending, (state) => {
        state.order_edit_loader = true;
      })
      .addCase(EditUserOrder.fulfilled, (state, { payload }) => {
        const full_list = state.my_order?.docs;

        const findIndex = full_list?.findIndex(
          (item) => item?._id === payload?.data?._id
        );

        full_list?.splice(findIndex, 1, payload?.data);

        state.my_order = { ...state.my_order, docs: full_list };

        state.order_edit_loader = false;
        state.message = payload?.message;

        state.orderIndicator = '';
      })
      .addCase(EditUserOrder.rejected, (state, { payload }) => {
        state.order_edit_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(EditUserSingleOrder.pending, (state) => {
        state.order_edit_single_loader = true;
      })
      .addCase(EditUserSingleOrder.fulfilled, (state, { payload }) => {
        state.order_edit_single_loader = false;
        state.message = payload?.message;

        state.myOrderDetails = payload?.data;
      })
      .addCase(EditUserSingleOrder.rejected, (state, { payload }) => {
        state.order_edit_single_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(EditAddressSingleOrder.pending, (state) => {
        state.order_edit_address_single_loader = true;
      })
      .addCase(EditAddressSingleOrder.fulfilled, (state, { payload }) => {
        state.order_edit_address_single_loader = false;
        state.message = payload?.message;

        state.myOrderDetails = payload?.data;
      })
      .addCase(EditAddressSingleOrder.rejected, (state, { payload }) => {
        state.order_edit_address_single_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetStatusAdvncaedCount.pending, (state) => {
        state.get_advance_count_loader = true;
      })
      .addCase(GetStatusAdvncaedCount.fulfilled, (state, { payload }) => {
        state.get_advance_count_loader = false;
        state.message = payload?.message;

        state.get_advanced_order_count = payload?.data;
      })
      .addCase(GetStatusAdvncaedCount.rejected, (state, { payload }) => {
        state.get_advance_count_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetAllUserOrderCount.pending, (state) => {
        state.get_all_user_count_loader = true;
      })
      .addCase(GetAllUserOrderCount.fulfilled, (state, { payload }) => {
        state.get_all_user_count_loader = false;
        state.message = payload?.message;

        state.get_all_user_count = payload?.data;
      })
      .addCase(GetAllUserOrderCount.rejected, (state, { payload }) => {
        state.get_all_user_count_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  clearState,
  updateOrderIndicator,
  updateMyOrderStatus,
  updateMySelectionOrdeState,
  updateMySingleOrderStatus,
} = userOrderSlice.actions;
export const userOrderSelector = (state) => state.user_order;

export default userOrderSlice.reducer;
